import * as constants from './constants';
import { createActions as createFormWidgetActions } from '../../components/Form/Widget';
import { createActionCreator } from '../../lib/Actions';

const createAction = createActionCreator('CUSTOMERS');
export const mainForm = createFormWidgetActions(constants.CUSTOMER_FORM_MAIN);
export const filesForm = createFormWidgetActions(constants.CUSTOMER_FILES_FORM);
export const organisationForm = createFormWidgetActions(constants.CUSTOMER_ORGANISATION_FORM);

export const UPDATE = createAction('UPDATE', ({ id, form, values }) => ({ id, form, values }));
